import { render, staticRenderFns } from "./release-note-loader.vue?vue&type=template&id=3d9284aa"
import script from "./release-note-loader.vue?vue&type=script&lang=js"
export * from "./release-note-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports